/* eslint-disable */
import { useState, useEffect, useRef, useCallback } from 'react';
import adminServices from '../../../services/adminServices';

const MAX_VIOLATIONS = 3;

/**
 * useProctoring — tab detection, violation counting, auto-submit.
 * No Firebase. Just stores violations via REST API.
 */
export default function useProctoring({ assessmentId, userId, attemptCount, active, onAutoSubmit }) {
  const [violationCount, setViolationCount] = useState(0);
  const [showWarning, setShowWarning] = useState(false);
  const [lastViolationType, setLastViolationType] = useState(null);
  const [autoSubmitted, setAutoSubmitted] = useState(false);
  const countRef = useRef(0);
  const lastFireRef = useRef(0);

  const recordViolation = useCallback((type, screenshot = null) => {
      const now = Date.now();
  if (now - lastFireRef.current < 500) return; 
  lastFireRef.current = now;
    if (!active || autoSubmitted || !assessmentId) return;

    countRef.current += 1;
    const count = countRef.current;
    setViolationCount(count);
    setLastViolationType(type);
    setShowWarning(false);  
    requestAnimationFrame(() => setShowWarning(true));
    // setShowWarning(true);

    // Store in backend
    adminServices.postExamViolation({
      assessmentId, userId, attemptCount, violationType: type,
      violationCount: count, screenshot,
    });

    // Auto-submit on 3rd violation
    if (count >= MAX_VIOLATIONS) {
      setAutoSubmitted(true);
      setTimeout(() => { onAutoSubmit?.(); }, 1500);
    }
  }, [active, autoSubmitted, assessmentId, userId, attemptCount, onAutoSubmit]);

  // Tab switch / window blur detection
  useEffect(() => {
    if (!active) return;

    const handleVisibilityChange = () => {
      if (document.hidden) recordViolation('TAB_SWITCH');
    };
    const handleBlur = () => { recordViolation('WINDOW_BLUR'); };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('blur', handleBlur);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleBlur);
    };
  }, [active, recordViolation]);

  // Webcam violation handler (called by WebcamProctor)
  const handleWebcamViolation = useCallback(({ type, screenshot }) => {
    recordViolation(type, screenshot);
  }, [recordViolation]);

  const dismissWarning = useCallback(() => setShowWarning(false), []);

  return {
    violationCount,
    showWarning,
    lastViolationType,
    autoSubmitted,
    handleWebcamViolation,
    dismissWarning,
  };
}
